import React from 'react'
import './styles.css'
import Find from '../share/components/Find/Find'
import CarouselSevices,{servicesTravel} from '../share/components/CarouselServices/CarouselSevices'
import ButtonsContactSecure from './ButtonContact/ButtonsContactSecure'
import FormInsurance from './FormInsurance/FormInsurance'
import AlliesInsurance from './AliesInsurance/AlliesInsurance'
import AnyQuestions from '../home/components/anyQuestion'
import UseTravelSecure from '../../viewModels/travelSecure/UseTravelSecure'



const TravelSecure = () => {



  return (
    <div className='contain-travel-secures'>
        <Find/>
        <CarouselSevices current={servicesTravel[6].title}/>
        <AlliesInsurance/>
        <ButtonsContactSecure/>
        <FormInsurance data={UseTravelSecure}/>
        <AnyQuestions title={"¿Tienes alguna duda?"}/>
    </div>
  )
}

export default TravelSecure